export const GO_RESULT_TEXT = `You will make your own decisions in your Next Great Adventure and want to equip you now to do so.`;
export const GO_SUGGESTION_TEXT = (attribute?: string) =>
  `Based on your answers, it seems like you could use more ${attribute}`;
export const GO_RESULT_DESCRIPTION = (challengeName: string) =>
  `Want to start following the path towards your goal? Try this challenge ${challengeName}.`;
export const GO_GO_TO_APP_BUTTON_TEXT = 'Go To App';
export const GO_CHANGE_EMAIL_BUTTON_TEXT = 'Change Email';
